import IntegrationService from './IntegrationService.js'

export const namespaced = true

export const state = {
  integrations: null,
}

export const mutations = {
  setIntegrations(state, integrations) {
    state.integrations = integrations
  },
  updateIntegration(state, data) {
    state.integrations.map(function (item) {
      if (item.IdentificationCode === data.code) {
        item.Status = data.status
        item.LegacyMode = data.legacyMode
      }

      return item
    })
  },
}

export const actions = {
  async fetchIntegrations(context, key) {
    const integrations = await IntegrationService.getAll(key)
    context.commit('setIntegrations', integrations)
  },
  async fetchIntegration(context, identificationCode) {
    return await IntegrationService.getIntegrationByCode(identificationCode)
  },
  async saveIntegration(context, data) {
    await IntegrationService.save(data.code, data.integration)
  },
  async connectIntegration(context, data) {
    return await IntegrationService.connect(data.code, data.model)
  },
  async performIntegrationAction(context, data) {
    return await IntegrationService.performAction(
      data.identificationCode,
      data.actionCode,
      data.model,
    )
  },
}

export const getters = {}
